import React from 'react';
import Translation from '../../../components/UI/Translation';

/* Translacje dla fitrów */
export const filterTranslations = {
  mainFilter: <Translation id='FILTER_ADD_FILTER' />,
  noData: <Translation id='FILTER_NO_FITLERS' />,
};
/* Translacje dla modala filtrów kolumn tabeli */
export const columnsFilterModalTranslations = {
  mainFilterTitle: <Translation id='COLUMNS_FILTER_MAIN_TITLE' />,
  mainSubTitle: <Translation id='COLUMNS_FILTER_MAIN_SUBTITLE' />,
  detailsTitle: <Translation id='COLUMNS_FILTER_DETAILS_TITLE' />,
  subDetailsTitle: <Translation id='COLUMNS_FILTER_DETAILS_SUBTITLE' />,
  cancel: <Translation id='CANCEL' />,
  confirm: <Translation id='CONFIRM' />,
};
/* Translacje dla widoku szczegółowego */
export const tableDetailsViewTranslations = {
  generateProtocol: <Translation id='BUTTON_GENERATE_PROTOCOL' />,
  signMarks: <Translation id='BUTTON_SIGN_MARKS' />,
  copyFinalMark: <Translation id='BUTTON_COPY_FINAL_MARKS' />,
};
/* Translacje dla przycisków widoku szczegółowego zakładki "Karty przedmiotów" */
export const subjectsCardsTranslations = {
  pairEffects: <Translation id='BUTTON_PAIR_EFFECTS' />,
  saveCard: <Translation id='BUTTON_SAVE_CARD_IN_SID' />,
};
/* Translacje dla rozwijanego panelu użytkownika */
export const userPanelTranslations = {
  settings: <Translation id='USER_PANEL_SETTINGS' />,
  help: <Translation id='USER_PANEL_HELP' />,
  logout: <Translation id='USER_PANEL_LOGOUT' />,
  loggedAs: <Translation id='ON_BEHALF_OF' />,
};
/* Translacje dla widoku szczegółowego studenta */
export const studentDetailsViewTranslations = {
  changeLog: <Translation id='BUTTON_CHANGE_LOG' />,
  signMarks: <Translation id='BUTTON_SIGN_MARKS' />,
  goToStudentTab: <Translation id='BUTTON_GO_TO_STUDENT_TAB' />,
  copyFinalMark: <Translation id='BUTTON_COPY_FINAL_MARKS' />,
};
